import script from "./PromoComponentThisIsWhy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoComponentThisIsWhy.vue?vue&type=script&setup=true&lang=ts"

import "./PromoComponentThisIsWhy.vue?vue&type=style&index=0&id=05ed6bbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ed6bbe"]])

export default __exports__